<app-headline>
  <h1 app-headline-title
  color="primary">Achievement types</h1>
</app-headline>

<ngrx-busy>
  <div class="ach-types">
    @for (achievementType of $achievementTypes | async; track achievementType.id) {
      <mat-card>
        <mat-card-header>
          <mat-card-title-group>
            <mat-card-title>{{achievementType.description}}</mat-card-title>
            <mat-card-subtitle><app-code appearance="text">{{achievementType.id}}</app-code></mat-card-subtitle>
            <div class="picture" [class.has-inactive-picture]="achievementType.inactive_picture_url">
              <img class="picture_url" mat-card-md-image [src]="achievementType.picture_url" [alt]="achievementType.description">
              @if (achievementType.inactive_picture_url) {
                <img class="inactive_picture_url" mat-card-md-image [src]="achievementType.inactive_picture_url" [alt]="achievementType.description + ' (inactive)'">
              }
            </div>
          </mat-card-title-group>
        </mat-card-header>
        <mat-card-content>
          {{achievementType.header}}
        </mat-card-content>
      </mat-card>
    }
  </div>
</ngrx-busy>
